import * as React from 'react';
import { useSearch } from '../hooks';

export type Facet = {
  id: string;
  name: string;
};

export type SelectedFacets = {
  [key: string]: Facet[];
};

const FacetsApplied: React.FC<{ clearLabel: string }> = ({ clearLabel }) => {
  const {
    state: { facets, selectedFacets },
    removeFacet,
    clearFacets
  } = useSearch();

  if (!Object.keys(selectedFacets).length) return null;

  const getFacetName = (category: string, key: string) => {
    const facet = facets.find(facet => facet.name === category);
    const tag = facet?.tags.find(facet => facet.id === key);

    return tag?.name;
  };

  const processedFacets = Object.keys(selectedFacets)
    .map(key => {
      return selectedFacets[key]
        .map(item => {
          const name = getFacetName(key, item);

          if (!name) return null;
          return { key, item, name };
        })
        .filter(facet => facet !== null);
    })
    .flat();

  if (!processedFacets.length) return null;

  return (
    <div className="search__facets-applied">
      <ul className="search__facets-applied__list">
        {processedFacets.map(facet =>
          facet ? (
            <li key={facet.item}>
              <button
                className="btn btn--primary"
                onClick={() => removeFacet(facet.key, facet.item)}
              >
                <span>
                  {facet.name}
                  <svg role="presentation">
                    <use xlinkHref="#close" />
                  </svg>
                </span>
              </button>
            </li>
          ) : null
        )}
      </ul>
      <button className="search__facets-applied__clear" onClick={clearFacets}>
        {clearLabel}
      </button>
    </div>
  );
};

export default FacetsApplied;
